const FULL_WIDTH_OFFSET = 0xfee0;

export const normalizeToHalfWidth = (value: string) =>
  value
    .replace(/[\uff01-\uff5e]/g, (fullWidthChar) =>
      String.fromCharCode(fullWidthChar.charCodeAt(0) - FULL_WIDTH_OFFSET)
    )
    // Convert space
    .replace(/\u3000/g, '\u0020');
